defaultDocumentTransform